module.exports = __webpack_public_path__ + "static/media/server_down_icon.f6fc7387.svg";